const create = (name, types) => {
  const constants = {};

  types.forEach(type => {
    constants[type] = `${name}/${type}`;
    constants[`${type}_REQUEST`] = `${name}/${type}_REQUEST`;
    constants[`${type}_SUCCESS`] = `${name}/${type}_SUCCESS`;
    constants[`${type}_FAILURE`] = `${name}/${type}_FAILURE`;
  });

  return constants;
}

export const sectors = create('sectors', ['FETCH_ALL']);
export const accounts = create('accounts', ['CREATE', 'LOGIN', 'RECOVER', 'RESET_PASSWORD', 'LOGOUT', 'FETCH_CURRENT']);
export const agents = create('agents', ['FETCH_CURRENT', 'UPDATE']);
export const router = create('router', ['CHANGE']);
export const root = create('root', ['CHANGE_TITLE', 'SHOW_NOTIFICATION', 'HIDE_NOTIFICATION', 'SHOW_ALERT', 'HIDE_ALERT', 'REQUEST', 'RESPONSE', 'SUBMIT_PASSWORD', 'REQUIRE_PASSWORD']);
export const projects = create('projects', ['FETCH_ALL', 'FETCH', 'CLEAR', 'CREATE_REPORT']);
export const reports = create('reports', ['FETCH_ALL']);
export const tasks = create('tasks', ['FETCH_ALL', 'CREATE_REPORT']);
export const taskForms = create('taskForms', ['FETCH_ALL', 'FETCH']);
export const submissions = create('submissions', ['FETCH_ALL', 'CREATE_REPORT','CREATE_REPORT_EMAILS']);



// WEBPACK FOOTER //
// ./src/constants/action-types.js